document.addEventListener("DOMContentLoaded", function() {
    const CONTENT_AREA = document.querySelector('main');
    const ICON_LINK_ANCHOR = 'arrow-down-right';
    const ICON_LINK_EXTERNAL = 'arrow-extern';
    const ICON_LINK_DOWNLOAD = 'arrow-download';

    if (CONTENT_AREA) {
        var links = CONTENT_AREA.querySelectorAll('a');

        links.forEach(function(link) {
            var href = link.getAttribute('href');
            if (href) {
                if (isInternalAnchorLink(href, link)) {
                    addClass(link, ICON_LINK_ANCHOR);
                } else if (isExternalLink(href)) {
                    addClass(link, ICON_LINK_EXTERNAL);
                    link.setAttribute('target', '_blank');
                }
                if (isDownloadLink(href)) {
                    addClass(link, ICON_LINK_DOWNLOAD);
                }
            }
        });
    }

    function isInternalAnchorLink(href, link) {
        return href.startsWith('#') && link.classList.length === 0;
    }

    function isExternalLink(href) {
        return href.startsWith('http') && !href.includes(window.location.hostname);
    }

    function isDownloadLink(href) {
        return href.endsWith('.pdf'); // Function to check if link is a download link
    }

    function addClass(link, className) {
        link.classList.add(className);
    }
});
